import HasID from './HasID';
import { Patient } from './Patient';

export interface PatientAllergyUpdate extends HasID {
    id: number,
    patientId: number,
    submitted: Date,
    allergyUpdate: string,
    processed: Date,
    processedBy: string,
    patient: Patient,
}

export class PatientAllergyUpdate {
    constructor(obj?: PatientAllergyUpdate) {
        if (obj) {
            Object.assign(this, obj);
            this.patient = new Patient(obj.patient);
        }
    }
}
